import { clearEnrolmentInfo } from "../api/persistence";

export function unenrol() {
    return async function () {
        clearEnrolmentInfo();
    };
}
